.root {
  z-index: var(--z-tooltips);
  max-width: 300px;
  padding: 0.25rem 0.5rem;
  color: white;
  background-color: black;
  border-radius: 0.25rem;
}

.ownTrigger {
  padding: 0;
}
